import { EMPLOYEE_ROUTES } from '../../../core/common/constants/employee.routing.constants';

/**
 * Placeholder standing for the lookup's own form control value. Every other
 * `:placeholder` is resolved from `relation_resource.extra_params`.
 */
export const LOOKUP_RESOURCE_ID_PLACEHOLDER = ':resource_id';

export interface LookupResourceRouteConfig {
  /** Joined with `/` and then prefixed by `TenantService.tenantPath()`. */
  segments: string[];
  /** A placeholder resolving to nullish drops that query param from the URL. */
  queryParams?: Record<string, string>;
}

export const LOOKUP_RESOURCE_ROUTES: Record<string, LookupResourceRouteConfig> =
  {
    project: {
      segments: [
        EMPLOYEE_ROUTES.PROJECTS.DETAILS,
        LOOKUP_RESOURCE_ID_PLACEHOLDER,
      ],
    },
    contract: {
      segments: [
        EMPLOYEE_ROUTES.PROJECTS.LIST,
        ':project_id',
        EMPLOYEE_ROUTES.PROJECTS.CONTRACTS.VIEW,
        LOOKUP_RESOURCE_ID_PLACEHOLDER,
      ],
    },
    invoice: {
      segments: [EMPLOYEE_ROUTES.INVOICES, LOOKUP_RESOURCE_ID_PLACEHOLDER],
    },
    vendor: {
      segments: [
        EMPLOYEE_ROUTES.VENDORS.DETAILS,
        LOOKUP_RESOURCE_ID_PLACEHOLDER,
      ],
    },
    request: {
      segments: [
        EMPLOYEE_ROUTES.REQUESTS.REQUEST_VIEW,
        LOOKUP_RESOURCE_ID_PLACEHOLDER,
      ],
    },
  };
